import React, { FunctionComponent } from 'react'
import { Rect, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Dashboard grid icon (2x2 asymmetric bento layout) used for dashboard navigation in side nav.
 * Supports outlined (default) and filled (selected) states.
 */
export const SideNavDashboardIcon: FunctionComponent<SideNavDashboardIconProps> = ({
  size = 32,
  fillColor,
  isFilled = false,
}) => {
  const { colors } = useTheme()
  const color = fillColor || colors.iconDefault

  const rectProps = isFilled ? { fill: color } : { fill: 'none', stroke: color, strokeWidth: 2 }

  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
      <Rect x={4} y={4} width={10.8} height={13.4} rx={3} {...rectProps} />
      <Rect x={17.2} y={4} width={10.8} height={8} rx={3} {...rectProps} />
      <Rect x={4} y={20} width={10.8} height={8} rx={3} {...rectProps} />
      <Rect x={17.2} y={14.6} width={10.8} height={13.4} rx={3} {...rectProps} />
    </Svg>
  )
}

export type SideNavDashboardIconProps = {
  size?: number
  fillColor?: string
  isFilled?: boolean
}
